export const MRP_METRICS = [
  {
    key: 'punishments_discord',
    label: 'Наказания Discord',
    short: 'Н·D',
    group: 'pun',
  },
  {
    key: 'punishments_as',
    label: 'Наказания AS',
    short: 'Н·AS',
    group: 'pun',
  },
  {
    key: 'chat_responses_discord',
    label: 'Ответы в Discord',
    short: 'О·D',
    group: 'resp',
  },
  {
    key: 'chat_responses_as',
    label: 'Ответы в AS',
    short: 'О·AS',
    group: 'resp',
  },
  {
    key: 'deleted_comments_as',
    label: 'Удалённые комментарии AS',
    short: 'Ком.',
    group: 'mod',
  },
  {
    key: 'closed_tickets',
    label: 'Закрытые тикеты',
    short: 'Тик.',
    group: 'tickets',
  },
];

export const MRP_ONLINE_METRIC = {
  key: 'minutes',
  label: 'Онлайн',
  short: 'Онл.',
  format: 'duration',
  group: 'online',
};

export function getMetricsForSection(_isSenior) {
  return MRP_METRICS;
}

/**
 * Единая метрика «Активность» = взвешенная сумма действий за неделю.
 * Веса можно править здесь — удобно подкрутить вклад каждой метрики.
 * 1 = обычный вклад, 0 = не учитывать.
 */
export const MRP_ACTIVITY_WEIGHTS = {
  punishments_discord: 1,
  punishments_as: 1,
  chat_responses_discord: 1,
  chat_responses_as: 1,
  deleted_comments_as: 1,
  closed_tickets: 1,
};

export function calcActivityScore(totals) {
  if (!totals) return 0;
  return Object.entries(MRP_ACTIVITY_WEIGHTS).reduce((sum, [key, weight]) => {
    const w = Number(weight);
    if (!w) return sum;
    return sum + (Number(totals[key]) || 0) * w;
  }, 0);
}

export function calcWeekDelta(current, previous) {
  const cur = Number(current) || 0;
  const prev = Number(previous) || 0;
  const diff = cur - prev;
  let percent = 0;
  if (prev > 0) percent = Math.round((diff / prev) * 100);
  else if (cur > 0) percent = 100;
  return { diff, percent, direction: diff > 0 ? 'up' : diff < 0 ? 'down' : 'flat' };
}

export function getMetricTotal(moderator, key) {
  if (key === 'minutes') return moderator.totalMinutes || 0;
  if (moderator.totalMetrics && moderator.totalMetrics[key] != null) {
    return moderator.totalMetrics[key];
  }
  if (!moderator.dailyStats) return 0;
  return moderator.dailyStats.reduce((sum, d) => sum + (Number(d[key]) || 0), 0);
}

export function getDayMetric(dayStat, key) {
  if (key === 'minutes') return dayStat.minutes || 0;
  return Number(dayStat[key]) || 0;
}
